/** * 多权限账户管理 * 徐杰 * 2019-7-22 **/
<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative; display: flex; justify-content: space-between; height: 28px; line-height: 28px">
        <Breadcrumb>
          <BreadcrumbItem to="/home"> <Icon type="icon iconfont icon-xitong" /> 系统首页 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-xitonghoutai" /> 系统管理 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-quanxian" /> 多权限账户管理 </BreadcrumbItem>
        </Breadcrumb>
        <i-button class="refresh" size="small" type="success">
          <Icon title="刷新" class="icon" type="ios-refresh" @click="reload" />
        </i-button>
      </div>

      <!-- 内容区域 -->
      <Card style="margin-top: 12px">
        <!-- 搜索栏 -->
        <div class="optdiv">
          <div>
            <Button type="primary" @click="toAddCompany"
              ><Icon type="md-add" style="position: relative; top: -0.125rem" />&nbsp;新增单位</Button
            >
          </div>
        </div>
        <!-- 数据表格 -->
        <i-table width="100%" :loading="tbLoading" :columns="columns2" :data="dictionlist" />
        <!-- 分页 -->
        <Page
          style="margin-top: 0.625rem"
          :current.sync="page"
          :page-size="row"
          :page-size-opts="[20, 50, 100, 200, 500]"
          show-total
          :total="total"
          show-sizer
          @on-change="onNextPage"
          @on-page-size-change="onPageSize"
        />
      </Card>

      <Modal v-model="modal1" title="删除提示" ok-text="确定删除" @on-ok="ok" @on-cancel="cancel">
        <Alert type="warning" show-icon>
          <template slot="desc"> 你确定要删除这个账户吗?请谨慎操作！ </template>
        </Alert>
      </Modal>

      <Modal v-model="modal2" title="重置提示" ok-text="确定重置" @on-ok="ok2" @on-cancel="cancel2">
        <Alert type="warning" show-icon>
          <template slot="desc"> 你确定要重置这个账户吗?请谨慎操作！ </template>
        </Alert>
      </Modal>
    </X-Layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal1: false,
      modal2: false,
      listindex: '', // 删除数组中的第几个数据
      cz_id: '', // 重置的id
      value: '',
      tbLoading: false, // 表格加载动画
      editIndex: -1, // 编辑使用
      edit_unit_name: '', // 编辑用单位名
      edit_account: '', // 编辑用账号

      columns2: [
        {
          type: 'index',
          title: '序号',
          align: 'center',
          width: 200,
          minWidth: 90,
          indexMethod: row => {
            return row._index + 1 + this.page * this.row - this.row;
          },
        },
        {
          title: '单位名称',
          align: 'center',
          minWidth: 200,
          render: (h, { row, index }) => {
            let edit;
            if (this.editIndex === index) {
              // 判断编辑序号是否等会当前行索引
              edit = [
                h('Input', {
                  style: { width: '300px' },
                  props: { value: row.unit_name },
                  on: {
                    input: val => {
                      this.edit_unit_name = val;
                    },
                  },
                }),
              ];
            } else {
              edit = row.unit_name;
            }

            return h('span', edit);
          },
        },
        {
          title: '账号',
          align: 'center',
          minWidth: 200,
          render: (h, { row, index }) => {
            let edit;

            if (this.editIndex === index) {
              // 判断编辑序号是否等会当前行索引
              edit = [
                h('Input', {
                  style: { width: '300px' },
                  props: { value: row.account },
                  on: {
                    input: val => {
                      this.edit_account = val;
                    },
                  },
                }),
              ];
            } else {
              edit = row.account;
            }

            return h('span', edit);
          },
        },

        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 300,
          render: (h, { row, index }) => {
            let edit;
            if (this.editIndex === index) {
              // 判断编辑序号是否等会当前行索引
              edit = [
                h(
                  'Button',
                  {
                    props: {
                      type: 'success',
                      size: 'small',
                      icon: 'md-create',
                    },
                    style: {
                      marginRight: '5px',
                    },
                    on: {
                      click: () => {
                        this.dictionlist[index].unit_name = this.edit_unit_name;
                        this.dictionlist[index].account = this.edit_account;
                        this.editIndex = -1;
                        this.editOK(row.user_id);
                      },
                    },
                  },
                  '确认',
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small',
                      icon: 'md-create',
                    },
                    style: {
                      marginRight: '5px',
                    },
                    on: {
                      click: () => {
                        this.editIndex = -1;
                      },
                    },
                  },
                  '取消',
                ),
              ];
            } else {
              edit = h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                    icon: 'md-create',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.edit_unit_name = row.unit_name;
                      this.edit_account = row.account;
                      this.editIndex = index;
                    },
                  },
                },
                '修改信息',
              );
            }
            return h('div', [
              edit,
              h(
                'Button',
                {
                  props: {
                    type: 'warning',
                    size: 'small',
                    icon: 'md-trash',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.chongzhi(row.user_id);
                    },
                  },
                },
                '重置密码',
              ),
              h(
                'Icon',
                {
                  props: {
                    type: 'ios-trash',
                    title: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '20px',
                    cursor: 'pointer',
                    color: '#ed4014',
                  },
                  on: {
                    click: () => {
                      this.deldata(row.user_id);
                    },
                  },
                },
                '删除',
              ),
            ]);
          },
        },
      ],
      dictionlist: [], // 字典信息
      total: 0, // 总条数
      page: 1, // 当前页数
      row: 20, // 当前页数
    };
  },

  mounted() {
    this.getDictona();
  },
  methods: {
    // 获取编码字典
    getDictona() {
      const api = this.ApiUrl + 'user/findAdmin';
      const data = {
        page: this.page,
        row: this.row,
      };
      this.tbLoading = true; // 开启加载动画
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.dictionlist = res.data.extend.pageInfo.records;
            this.total = res.data.extend.pageInfo.total;
          }
          this.tbLoading = false; // 关闭加载动画
        },
        res => {
          this.tbLoading = false; // 关闭加载动画
        },
      );
    },
    /**
     * 确定删除
     */
    ok() {
      const api = this.ApiUrl + 'user/delById';
      const data = {
        user_id: this.listindex,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.getDictona();
          }
          this.$Message.success('成功删除');
        },
        res => {
          this.$Message.warning('删除失败');
        },
      );
    },
    /**
     * 确定重置
     */
    ok2() {
      const api = this.ApiUrl + 'user/updateUser';
      const data = {
        user_id: this.cz_id,
        account: '',
        password: '',
        unit_name: '',
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.$Message.success('操作成功');
          } else {
            this.$Message.error('操作失败!');
          }
        },
        res => {},
      );
    },
    /**
     * 点击取消事件
     */
    cancel() {
      this.$Message.info('取消删除');
    },
    /**
     * 点击取消事件
     */
    cancel2() {
      this.$Message.info('取消重置');
    },
    // 表格删除事件
    deldata(index) {
      this.modal1 = true;
      this.listindex = index;
    },

    /**
     * 编辑确定按钮
     */
    editOK(id) {
      const api = this.ApiUrl + 'user/updateUser';
      const data = {
        unit_name: this.edit_unit_name,
        account: this.edit_account,
        password: '',
        user_id: id,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.$Message.success('修改成功');
          } else {
            this.$Message.error('修改失败!');
          }
        },
        res => {},
      );
    },
    /**
     * 确定重置
     */
    chongzhi(id) {
      this.modal2 = true;
      this.cz_id = id;
    },
    // 切换显示的页数
    onPageSize(e) {
      this.row = e;
      this.getDictona();
    },
    // 切换下一页
    onNextPage(e) {
      this.page = e;
      this.getDictona();
    },
    // 刷新页面
    reload() {
      location.reload();
    },
    /**
     * 点击确定事件1
     */
    clickOK1() {
      this.$Message.info('点击确认');
    },
    /**
     * 点击取消事件
     */
    clickCancel1() {
      this.$Message.info('点击取消');
    },

    /**
     * 跳转到添加企业
     */
    toAddCompany() {
      this.$router.push({
        name: 'addJurisdiction',
        params: { admid: 123 },
      });
    },
  },
};
</script>

<style scoped>
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.optdiv {
  display: flex;
  padding: 0.625rem 0;
  justify-content: space-between;
}

.tabdiv {
  margin-left: 1.25rem;
}
</style>
